import React, { useEffect } from 'react'
import { useFileUpload } from 'app/api/useFileUpload'
import { API_BASE_URL, endpoints } from 'app/api/endpoints'
import { QuotationUploadInput, QuotationUploadReponse } from 'EstraSuppliers'
import { InputFile } from 'app/components/ui/form/InputFile'
import { FormFeedback } from 'app/components/ui/form/FormFeedback'
import { Label } from 'app/components/ui/form/Label'
import { Text } from 'app/components/ui/Text'
import styled from 'styled-components'
import { Button } from 'app/components/ui/Button'
import { themeEstra } from 'app/styles/themeEstra'
import { validateInputPdfFile } from 'app/utils/file'

interface Props {
  quotationId: string
  isInModal?: boolean
  onSuccessUpload: () => void
}

export const UploadQuotation: React.FC<Props> = ({
  onSuccessUpload,
  quotationId,
  isInModal,
}) => {
  const [fileToUpload, setFileToUpload] = React.useState<File | null>()
  const [isFileValid, setIsFileValid] = React.useState<boolean | null>(null)

  const apiUploadURL = `${API_BASE_URL}/${endpoints.uploadQuotation}/${quotationId}`
  const {
    uploadFile,
    uploadIsLoading,
    uploadSuccess,
    uploadError,
  } = useFileUpload<QuotationUploadInput, QuotationUploadReponse>(apiUploadURL)

  // on upload success refetch actor
  useEffect(() => {
    if (uploadSuccess && uploadSuccess.quotation_url) {
      onSuccessUpload()
    }
  }, [uploadSuccess?.quotation_url])

  const inputFileName = 'quotationInput'

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        if (fileToUpload && fileToUpload.name) {
          uploadFile(
            {
              file: fileToUpload,
            },
            {
              limitInMb: 10,
            }
          )
        }
      }}
    >
      <InputGroup>
        <Label
          color={isInModal ? themeEstra.color.primari.neroEstra : 'white'}
          htmlFor={inputFileName}
        >
          Carica preventivo
        </Label>
        <InputFile
          name={inputFileName}
          accept='image/png, image/jpeg, image/jpg, application/pdf'
          selectedFileName={fileToUpload?.name}
          onChange={e => {
            const { file, isValid } = validateInputPdfFile(e)
            setIsFileValid(isValid as boolean)
            if (file && isValid) {
              setFileToUpload(file)
            }
          }}
        />
        <Text
          variant='s12'
          color={isInModal ? themeEstra.color.primari.grigioEstra : 'white'}
          mt={0.5}
          isItalic
        >
          Formato immagine o PDF, dimensione massima 10 MB
        </Text>
        {uploadError || isFileValid === false ? (
          <FormFeedback variant='error'>
            {uploadError || 'Il file scelto non è in un formato valido.'}
          </FormFeedback>
        ) : null}
      </InputGroup>

      {fileToUpload && (
        <ButtonWrapper isInModal={isInModal}>
          <Button
            variant={'nero'}
            disabled={
              uploadIsLoading ||
              Boolean(uploadSuccess && uploadSuccess.quotation_url)
            }
          >
            {uploadIsLoading ? 'Caricamento...' : 'Carica File'}
          </Button>
        </ButtonWrapper>
      )}
    </form>
  )
}

const InputGroup = styled.div``

const ButtonWrapper = styled.div<{ isInModal?: boolean }>`
  display: flex;
  justify-content: ${({ isInModal }) =>
    isInModal ? 'flex-end' : 'flex-start'};
  margin-top: 1rem;
`
